import { render, staticRenderFns } from "./menuProfilePage.vue?vue&type=template&id=5aac1f9f&scoped=true&"
import script from "./menuProfilePage.vue?vue&type=script&lang=js&"
export * from "./menuProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./menuProfilePage.vue?vue&type=style&index=0&id=5aac1f9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac1f9f",
  null
  
)

export default component.exports